import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import { FooterItem } from '.';

export const useSettingList = () => {
  const { t } = useTranslation();
  const { home, account } = useStore();
  const { confList } = home;
  const { lang } = account;

  const { notice_center } = confList;

  const {
    user_agreemen,
    fee_explain,
    work_order,
    instructions,
    help_center,
    larding_page_url,
    disclaimer,
    risk_warning,
    verification_channel,
    about_us,
    privacy,
    cooperation,
  } = confList;

  const produceList = [
    // { title: t('footer.appDl'), url: larding_page_url },
    { title: t('footer.spot'), url: '/spot/trade/btc_usdt' },
    { title: t('footer.futures'), url: '/futures/contract/u_based/btc_usdt' },
    { title: t('footer.copyTrade'), url: `/${lang}/copy-trading/futures` },
    // { title: t('footer.crypto'), url: '/account/otc/index' },
    // { title: t('footer.help'), url: help_center },
    { title: t('footer.feeRate'), url: fee_explain },
  ];
  const aboutUsList = [
    { title: t('footer.userAgreement'), url: user_agreemen },
    { title: t('footer.privacyPolicy'), url: privacy },
    { title: t('footer.disclaimer'), url: disclaimer },
    // { title: t('footer.verifyChannal'), url: verification_channel },
    { title: t('footer.risk_tips'), url: risk_warning },
  ];
  const introduceList = [
    { title: t('footer.help'), url: help_center },
    { title: t('footer.notice'), url: notice_center },
    { title: t('footer.aboutUs'), url: about_us },

    // { title: t('footer.ticket'), url: work_order },
    { title: t('footer.business'), url: cooperation },
  ];
  return useMemo<FooterItem[]>(
    () => [
      {
        title: t('footer.aboutUs'),
        children: aboutUsList,
      },
      {
        title: t('footer.technicalSupport'),
        children: produceList,
      },

      {
        title: t('footer.termsInfo'),
        children: introduceList,
      },
    ],
    [t, produceList, introduceList, aboutUsList],
  );
};
